export default "__VITE_ASSET__B58GRS9j__"